<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <div class="default-text large" [innerHTML]="textCopy.permitTypeTitle"></div>
    <div class="question-block" *ngFor="let permitType of permitTypes">
      <div class="question-label checkbox" (click)="onSelectPermitType(permitType)"
           [ngClass]="{'selected': permitType.value === 'y'}">
        <i class="checkbox-placeholder"></i>
        <span [innerHTML]="permitType.text"></span>
      </div>
    </div>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <div class="default-text large" [innerHTML]="textCopy.differentNameTitle"></div>
    <input aria-label=""  class="app-input" type="text" [(ngModel)]="differentName" />
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <radio-question [data]="provePermit.data" [valueSelected]="provePermit.valueSelected"
                    (selectAnswer)="onProvePermitSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <select-question [data]="permitCancellation.data" [active]="provePermit.valueSelected !== 'n'"
                     [valueSelected]="permitCancellation.valueSelected"
                     (selectAnswer)="onPermitCancellationSelected($event)"></select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">5</i>
    <div class="default-text large" [innerHTML]="textCopy.permitMistakeTitle"></div>
    <multiple-select-question [data]="permitMistake.data" [valuesSelected]="permitMistake.valuesSelected"
                              [active]="permitTypes[2].value === 'y'"
                              (selectAnswer)="onPermitMistakeSelected($event)"></multiple-select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">6</i>
    <explain-question [data]="explain.data" [active]="explain.active"
                      [valueSelected]="explain.valueSelected"
                      [validationSelected]="explain.validationSelected"
                      [validationText]="explain.validationText"
                      (selectAnswer)="onExplainSelected($event)"></explain-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
